import { VisitStatus } from '../enums';

interface IStepHistoricDto {
    type: string;
    icon: string;
    name: string;
    finishTripsInProgress: boolean;
    normalDuration: string;
    maxDuration: string;
    minDuration: string;
    customerId?: string;
    zones?: string[];
    action?: string;
    slug?: string;
    completedAt?: string;
    overwritePlanned?: string;
    plannedAt?: string;
    estimatedAt?: string;
    triggeredAt?: string;
    stateDefinition?: string;
    finishTripAfter?: string;
    isNonOperative?: boolean;
}

interface IDeliveryHistoricDto {
    legacyDeliveryId: string;
    status: string;
    statusCode: string;
    subStatus: string;
    photos: string[];
    comments: string[];
    signature: string;
}

interface ITriggerOrderHistoricDto {
    checkpointIndex: number;
    stepIndex: number;
}

export interface ICheckpointHistoricDto {
    checkpointDefinitionId: string;
    transitionStateDefinition?: string;
    stateDefinition: string;
    name: string;
    delivery?: IDeliveryHistoricDto;
    steps: IStepHistoricDto[];
    type: string;
    location: string;
    visitStatus: VisitStatus;
}

export interface ICreateTripHistoricDto {
    originalId: string;
    organizationId: string;
    tripDefinition: string;
    delayedYellow: string;
    delayedRed: string;
    pendingColor: string;
    finishedColor: string;
    scheduledStart: string;
    scheduledFinish: string;
    realStart: string;
    realFinish: string;
    finishReason: string;
    finishBy: string;
    locale: string;
    tripLifetime: string;
    tripStartedLifetime: string;
    ttlFinishedTrips?: string;
    vehicle: string;
    driver: string;
    tripCode: string;
    terminalName: string;
    totalDelay: number;
    checkpoints: ICheckpointHistoricDto[];
    meters: number;
    minPercentage: number;
    maxPercentage: number;
    maxDrivingTime?: number;
    restingTime?: number;
    maxDailyDrivingTime?: number;
    drivingTimeWindowTolerance?: number;
    metersWithoutOptions: number;
    finishOnLastCheckpointStep: boolean;
    forceShowLastCheckpointNext: boolean;
    drivingTimeWindow?: [string, string][];
    stopped: boolean;
    drivenTime: number;
    triggerOrder: ITriggerOrderHistoricDto[];
    alerts?: string[];
    logs?: string[];
    isDeleted?: boolean;
    deletedAt?: string;
}
